import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss";
import { useEffect, useState } from "react";
import RatingService from "../../../../services/rating.service";
import useCustomToast from "../../../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";
import RatingMilestoneTable from "../../../../components/Training/Rating/RatingMilestoneTable";
import StudentPagesProvider from "../../../../providers/StudentPagesProvider";

const rating_types: any = {
  private_pilot: {
    label: "Private Pilot Ratings",
    models: {
      "single_engine": "Airplane, Single-Engine",
      "multi_engine": "Airplane, Multi-Engine"
    }
  },
  instrument: {
    label: "Instrument Ratings",
    models: {
      "airplane": "Airplane",
      "airplane_142_training": "Airplane (Part 142 Training)"
    }
  },
  commercial: {
    label: "Commercial Ratings",
    models: {
      "single_engine_land": "Airplane, Single-Engine",
      "multi_engine_land": "Airplane, Multi-Engine"
    }
  },
  dpe: {
    label: "DPE Ratings",
    models: {
      "single_engine_land": "Airplane, Single-Engine",
      "multi_engine_land": "Airplane, Multi-Engine"
    }
  },
  cfi: {
    label: "CFI Ratings",
    models: {
      "single_engine_land": "Airplane, Single-Engine land",
      "multi_engine_land": "Airplane, Multi-Engine land"
    }
  }
}

function Ratings() {
  const [models, setModels] = useState<any>({})
  const [showRatings, setShowRatings] = useState(false)
  const [selectedRating, setSelectedRating] = useState<any>(null)
  const [selectedModel, setSelectedModel] = useState<any>(null)


  const [milestones, setMilestones] = useState<any>([])

  const customToast = useCustomToast()

  useEffect(() => {
    if (selectedRating) {
      setModels(rating_types[selectedRating]['models'])
    }
  }, [selectedRating])

  const getRatingMilestones = async () => {

    if (!selectedRating) return customToast("Please select rating type", "error")
    if (!selectedModel) return customToast("Please select model type", "error")

    const result: any = await RatingService.getRatings(selectedRating, selectedModel)
    if (result?.results?.length) {
      setMilestones(result?.results?.sort((a: any, b: any) => b?.completed - a.completed))
      setShowRatings(true)
    }
  }



  return (
    <StudentPagesProvider>
      <LayoutProvider>
        <div className="ratings_page">
          <Toaster />
          <h2 className="heading2">Ratings Progress</h2>
          <div className="ratings_wrapper">
            <div className="row">
              <div className="col col-lg-3 col-md-12 left">
                <div className="track_form">
                  <h3 className="heading3">Track Your Progress</h3>
                  <div className="input_group">
                    <label htmlFor="">Choose Rating Type</label>
                    <select className="form-select" onChange={(e) => {
                      setSelectedRating(e.target.value)
                      setSelectedModel("")
                    }} value={selectedRating}>
                      <option value="">Choose Rating Type</option>
                      {Object.keys(rating_types)?.map((key: any, i) => {
                        return <option value={key} key={i}>{rating_types[key]['label']}</option>
                      })}
                    </select>
                  </div>
                  <div className="input_group">
                    <label htmlFor="">Modal Type</label>
                    <select className="form-select" onChange={(e) => setSelectedModel(e.target.value)} value={selectedModel}>
                      <option value="">Modal Type</option>
                      {Object.keys(models)?.map((model: string, i: number) => {
                        return <option value={model} key={i}>{models[model]}</option>
                      })}
                    </select>
                  </div>

                  <div className="input_group">
                    <button className="button" onClick={() => getRatingMilestones()}>Check Ratings</button>
                  </div>
                </div>
              </div>
              {showRatings && <RatingMilestoneTable milestones={milestones} />}
            </div>
          </div>
        </div>
      </LayoutProvider>
    </StudentPagesProvider>
  );
}

export default Ratings;
